import CryptoJS from 'crypto-js'

/**
 * 工具类
 */

// 加密
export default{

  set(word, keyStr) {

    // word = JSON.stringify(word)     //  对象/数组转Json

    keyStr = keyStr ? keyStr: 'honglandatas2659';
    var key  = CryptoJS.enc.Utf8.parse(keyStr);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 } );
    return encrypted.toString();
  },

  // 解密
  get(word, keyStr) {
    keyStr = keyStr ? keyStr: 'honglandatas2659';
    var key  = CryptoJS.enc.Utf8.parse(keyStr);                     
    var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 } );
    let decrypt_text = CryptoJS.enc.Utf8.stringify(decrypt).toString()
    return decrypt_text
  },
}                                                        



// WEBPACK FOOTER //
// ./src/components/Aes/index.js